import cssText from './light.css';

export function configureLightTheme(ace: AceAjax.Ace) {
  ace.define('ace/theme/light', [], (require, exports, module) => {
    exports.isDark = false;
    exports.cssClass = 'ace-mode-light';
    exports.cssText = cssText;
    const dom = require('../lib/dom');
    dom.importCssString(exports.cssText, exports.cssClass);
  });
}
